<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
  // Sobrescreve a rota padrão de Relatórios (`${type}_reports_show`) — usado
  // pelo Dashboard, cujo "ver detalhe" abre uma rota própria em `/painel`.
  routeName: {
    type: String,
    default: '',
  },
});

const resolvedRouteName = computed(
  () => props.routeName || `${props.row.original.type}_reports_show`
);
</script>

<template>
  <router-link
    :to="{ name: resolvedRouteName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
</template>
